import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { Flex } from '@rover/kibble/core';
import { getCookie } from '@rover/rsdk/src/modules/Network/cookies';
import { getSourceDescription } from '@rover/rsdk/src/modules/Network/userAgent';
import useCountryConfigurationShim from '@rover/shared/js/hooks/useCountryConfigurationShim';
import useFrontendConfigurationShim from '@rover/shared/js/hooks/useFrontendConfigurationShim';
import getBrandDisplayName from '@rover/shared/js/utils/getBrandDisplayName';
import fireDataLayerEvent from '@rover/utilities/fireDataLayerEvent';

import FAQSection from './components/FAQSection';
import FourPillarsSection from './components/FourPillarsSection';
import LandingSection from './components/LandingSection';
import TestimonialsSection from './components/TestimonialsSection';
import { RoverProtectEvents } from './analytics';

export type Props = {
  personOpk?: string;
};

const RoverProtectPage = ({ personOpk }: Props): JSX.Element => {
  const platform = getSourceDescription();
  const cookieId = getCookie('rover_cid');
  const { current } = useCountryConfigurationShim();
  const { language } = useFrontendConfigurationShim();
  useEffect(() => {
    fireDataLayerEvent(
      RoverProtectEvents.PageView({ source: platform, personId: personOpk, cookieId })
    );
  }, [personOpk]);

  const backgroundCheckUrl =
    current?.countryCode === 'US' || current?.countryCode === 'CA'
      ? '/background-checks'
      : '/id-verified';

  return (
    <>
      <Helmet>
        <title>{`RoverProtect | ${getBrandDisplayName()}`}</title>
      </Helmet>
      <Flex flexDirection="column" justifyContent="center">
        <LandingSection personOpk={personOpk} cookieId={cookieId} language={language} />
        <FourPillarsSection
          personOpk={personOpk}
          cookieId={cookieId}
          language={language}
          backgroundCheckUrl={backgroundCheckUrl}
          roverGuaranteeUrl={current?.roverGuaranteeUrl}
          veterinaryCareLimit={current?.formattedVetCareReimbursementAmount}
        />
        <FAQSection
          roverGuaranteeUrl={current?.roverGuaranteeUrl}
          veterinaryCareLimit={current?.formattedVetCareReimbursementAmount}
        />
        <TestimonialsSection />
      </Flex>
    </>
  );
};

export default RoverProtectPage;
